<template>
    <div class="mb-1">
        <label
            class="form-label"
            :class="{ 'form-label--disabled': disabled }"
            :for="name"
        >
            {{ label }}
            <span v-if="!required">(optioneel)</span>
        </label>

        <input
            :id="name"
            class="form-input"
            :class="{
                'form-input--error': error,
                'form-input--disabled': disabled
            }"
            :disabled="disabled"
            :name="name"
            :placeholder="placeholder"
            :type="type"
            :value="value"
            :maxlength="maxLength"
            :autocomplete="autoComplete ? '' : 'off'"
            @input="onInput"
        />

        <div class="form-error" :class="{ 'form-error--visible': error }">
            {{ error }}
        </div>
    </div>
</template>

<script>
import FormComponentMixin from '@/js/mixins/form-component-mixin';

export default {
    mixins: [FormComponentMixin],

    props: {
        autoComplete: {
            type: Boolean,
            default: false
        },
        placeholder: {
            type: String,
            default: ''
        },
        type: {
            type: String,
            default: 'text'
        },
        value: {
            type: String,
            default: ''
        }
    },

    methods: {
        onInput(e) {
            this.$emit('input', e.target.value);
        }
    }
};
</script>
